
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog'
import React, { FC, useState, useEffect } from 'react'
import { tawreedTranslationService } from '../../../../common/translations';
import { TawreedFormField, TawreedInputFile, TawreedInputNumber, TawreedInputText } from '../../../../common';
import { StatesDropdown } from '../../../states';
import { TawreedFile } from '../../../upload';

export interface FinanceDocumentUploadDialogProps {
    visible: boolean;

    hide: () => void;

    accept: (data: { file: File, title: string; }) => void;

}

export const FinanceDocumentUploadDialog: FC<FinanceDocumentUploadDialogProps> = ({ visible, hide, accept }) => {


    const [dialogState, setDialogState] = useState<{
        file: File | undefined,
        title: string | undefined
    }>({
        file: undefined,
        title: undefined
    });


    useEffect(() => {

        setDialogState({
            file: undefined,
            title: undefined
        })
    }, [visible])


    const FinanceDocumentUploadDialogFooter = () => {
        return (<div>
            <Button label={tawreedTranslationService.translate('lbl_cancel')} icon="pi pi-times" onClick={hide} className="p-button-text" /*disabled={dialogState.loading}*/ />
            <Button onClick={() => {
                accept({
                    file: dialogState.file!,
                    title: dialogState.title!
                });
                hide();
            }} label={tawreedTranslationService.translate('lbl_accept')} icon="pi pi-check" disabled={!dialogState || !dialogState.file || !dialogState.title}
            // loading={dialogState.loading}
            />
        </div>);
    }

    return (
        <Dialog style={{}} header={tawreedTranslationService.translate('lbl_document_files_add_file')} visible={visible} footer={<FinanceDocumentUploadDialogFooter />} onHide={hide} draggable={false} position="top" closable={false} closeOnEscape={false}>
            <form className="formgrid grid" >
                <React.Fragment>
                    <TawreedFormField title="lbl_files_file" className="field col-12 align" name="file">
                        <TawreedInputFile render='standalone' name="file" onChange={
                            (e: TawreedFile | undefined) => setDialogState({ ...dialogState, file: e && e.value instanceof File ? e.value : undefined })
                        } value={dialogState.file} />
                    </TawreedFormField>
                    <TawreedFormField name="title" title="lbl_document_files_title" className="field col-12 md:col-12">
                        <TawreedInputText value={dialogState?.title} name="title" rules={{ required: "msg_field_is_required" }} render="standalone" onChange={(e) => {
                            setDialogState({ ...dialogState, title: e.target.value });
                        }} />
                    </TawreedFormField>

                </React.Fragment>
            </form>
        </Dialog>
    )
}
